const CA = 'Communicating for America'
const FIDELITY = 'U65 - Fidelity'

export const getCarrierName = (value: string): string => {
  return value === CA ? FIDELITY : value
}
